import { render, staticRenderFns } from "./GroupChat.vue?vue&type=template&id=35a36573&scoped=true&lang=html&"
import script from "./GroupChat.vue?vue&type=script&lang=js&"
export * from "./GroupChat.vue?vue&type=script&lang=js&"
import style0 from "./GroupChat.vue?vue&type=style&index=0&id=35a36573&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a36573",
  null
  
)

export default component.exports